<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Controleren"
      @next-step="$router.push({ name: 'printOrderConfirm' })"
      @prev-step="$router.push({ name: 'printOrderDeliver' })"
    ></next-prev-menu>
    <invoice
      :orderDetails="orderDetails"
      :shop="shop"
      @updateOrder="updateOrder"
      @updateProject="updateProject"
    ></invoice>
  </div>
</template>

<script>
import { usePrintOrderStore } from '@/features/printOrder/PrintOrder.store'
import { mapStores } from 'pinia'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import Invoice from '@/components/Invoice.vue'

export default {
  data() {
    return {}
  },
  components: {
    NextPrevMenu,
    Invoice
  },
  methods: {
    updateOrder(val) {
      this.printOrderStore.updateOrderDetails(val[0], val[1])
    },
    updateProject(project) {
      this.printOrderStore.updateProject({
        name: project.name || '',
        id: project.id || 0
      })
    }
  },
  computed: {
    ...mapStores(usePrintOrderStore),
    orderDetails() {
      return this.printOrderStore.orderDetails
    },
    shop() {
      return this.printOrderStore.shop
    },
    custom() {
      return this.printOrderStore.customFields
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped></style>
